module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAA3CAYAAAB+fggjAAAAwklEQVRoge3awQnCMBiG4U/x3hU8uEZwCcdwHAdwBEdwEA8dQSdQlPYSiKa8oWnkeyGHQCAP/Lm1qxDCUwtuvWScWgBuov1W0qOSZayT1I+bGPjG3auwEvkN0gykGUgzkGYgzUCagTQDaQbSDKQZSDOQZiDNQJqBNANpBtIMpBlIM5AWf8j51lHSodC952H9bApwJ2lfCHjNPfhXIz5JuhS6t88482kK8DasWWtuxF0lR9IQA7Pfxlw1MeLavwCkk/QCo2YPBWVUj8oAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/phone.png
// module id = JhOT
// module chunks = 1